import { findCountryByPhoneNumber } from "./international";

const countryAndOperators = {
	Afghanistan: [
		"Afghan Wireless Communication Company   :[AWCC  ]",
		"Areeba   :[MTN  ]",
		"Etisalat",
		"Roshan",
		"Afghan Telecom",
	],
	Albania: [
		"Albania Mobile Communications   :[AMC  ]",
		"Vodafone Albania",
		"Eagle Mobil",
		"PLUS COM.   :[PLUS  ]",
	],
	Algeria: ["Djezzy", "Mobilis", "Nedjma"],
	Andorra: ["Mobiland_Andorra Tel"],
	Angola: ["Unitel", "Movicel", "Africell"],
	Argentina: [
		"*",
		"AMX Argentina-CLARO",
		"Mtel Argentina Radiomensaje S.A",
		"Nextel Communications Argentina S.A",
		"Telecom Personal S.A",
		"Telefonica Comunicaciones Personales S.A",
	],
	Armenia: [
		"ArmenTel",
		"Vivacell   [K-Telecom  ]",
		"Karabagh",
		"Orange Armenia CJSC",
	],
	Aruba: ["New Millennium Telecom Services N.V.   [Digicel  ]", "SETAR N.V"],
	Australia: [
		"Telstra Corporation",
		"Vodafone Network Pty Ltd",
		"Optus Mobile Pty Ltd",
		"*",
		"Hutchison   G",
		"Lycamobile",
	],
	Austria: [
		"mobilkom austria A  ",
		"Hutchison   G Austria GmbH",
		"Orange",
		"YESSS! Telekommunikation GmbH",
		"T-Mobile Austria GmbH",
		"*",
		"Mundio Mobile",
		"Lycamobile",
		"MASS Response Servic",
	],
	Azerbaijan: [
		"azercell",
		"Azerfon",
		"Bakcell",
		"Catel   :[CDMA-        ]",
		"Naxtel",
	],
	Bahrain: ["batelco", "MTC Vodafone  :[zain  ]", "Viva"],
	Bangladesh: [
		"AkTel  :[Robi  ]",
		"City Cell",
		"Grameen Phone",
		"Banglalink",
		"Teletalk",
	],
	Belarus: [
		"MTS",
		"Belarusian Telecommunications Network CJSC   :[BeST  ]",
		"BelCel JV",
		"JV Mobile Digital Communications Ltd   :[Velcom  ]",
	],
	Belgium: [
		"Base N.V.",
		"Mobistar S.A.",
		"Proximus",
		"*",
		"Lycamobile",
		"MEDIALAAN",
	],
	Belize: ["SPEEDNET   :[prepaid  ]", "Belize Telecommunication Ltd"],
	Benin: [
		"BBCOM  :[Bell Benin  ]",
		"EtisalatBenin  :[TELCEL",
		"Office des  :[Libercom  ]",
		"Spacetel-Benin   :[MTN  ]",
		"Glomobile Benin Ltd.",
		"SBIN   :[Societe Beninoise d Infrastructures Numeriques  ]",
	],
	Bhutan: ["B-Mobile", "TashiCell"],
	Bolivia: ["Entel", "Telecel  :[Tigo  ]", "Nuevatel PCS De Viva"],
	"Bosnia and Herzegovina": [
		"ERONET",
		"GSM BIH   :[BH Telecom  ]",
		"RS Telecom   :[m:tel  ]",
	],
	Botswana: ["Mascom Wireless", "Orange Botswana", "Botswana Telecom BTC"],
	Brazil: [
		"*",
		"Brasil Telecom-Oi",
		"Claro-Americel",
		"CTBC Celular",
		"Nextel",
		"Oi-TNL",
		"Sercomtel Celular",
		"TIM",
		"Vivo",
		"Unicel do Brasil",
		"DATORA MOBILE TELECO",
		"PORTO SEGURO TELECOM",
		"OPTIONS COMPUTADORES",
		"TERAPAR PARTICIPACOE",
	],
	"Brunei Darussalam": [
		"B-Mobile Communications",
		"DST Communications Sdn Bhd",
	],
	Bulgaria: ["Cosmo Bulgaria Mobile", "BTC mobile", "MobilTel AD"],
	"Burkina Faso": [
		"Orange  :[Celtel  ]",
		"Telmob S.A.",
		"Telecel Faso  :[Moov  ]",
	],
	Burundi: [
		"Africell",
		"Spacetel",
		"ECONET LEO",
		"ONATEL",
		"HITS Telecom",
		"Viettel   :[Lumitel  ]",
	],
	Cambodia: [
		"Camshin  :[Mfone  ]",
		"CamGSM   :[Mobitel  ]",
		"Latelz Co. Ltd SMART",
		"CADCOMMS  :[QB  ]",
		"VIETTEL   :[Metfone  ]",
		"S Telecom",
		"BeelineKH   :[Sotelco  ]",
		"Excell",
	],
	Cameroon: ["Orange", "MTN", "Nexttel", "Camtel"],
	"Cape Verde": ["CV Telecom   :[Movel  ]", "T+ Telecom"],
	"Central African Republic": [
		"INVIVENT",
		"NationLink Telecom",
		"Orange",
		"Telecel",
		"Atlantique  :[Moov CAR  ]",
	],
	Chad: ["Celtel", "Millicom   :[Tchad Mobile  ]"],
	Chile: [
		"*",
		"Claro",
		"TelefonicaMovistar",
		"ENTEL PCS",
		"EntelTelefonia",
		"Nextel SA",
		"VTR Banda Ancha SA",
	],
	China: ["China Mobile", "China Unicom", "China Telecom"],
	Colombia: ["*", "Comcel S.A   :[CLARO  ]", "Telef  :[Movistar  ]", "Tigo"],
	Comoros: ["HURI", "Telecom Malagasy   :[Telma  ] TELCO"],
	Congo: ["Celtel Congo", "Warid Congo", "MTN  :[Libertis Tele  ]"],
	"Cook Islands": ["Telecom Cook Islands"],
	"Costa Rica": [
		"Instituto Costarricense de Electricidad   :[ICE  ]",
		"Movistar",
		"Claro",
	],
	Croatia: ["vipnet", "Tele  ", "T-Mobile HR"],
	Cuba: ["Cubacel"],
	Cyprus: ["CYTAmobile-Vodafone", "MTN   :[Areeba Ltd  ]", "PrimeTel PLC"],
	"Czech Republic": ["Vodafone", "T-Mobile", "O  ", "Ufone"],
	"Democratic Republic of the Con": [
		"Celtel  :[Zain  ]",
		"Vodacom",
		"Sait-T  :[Tigo  ]",
		"Africell",
		"CCT  :[Orange  ]",
	],
	Denmark: [
		"Barablu Mobile",
		"Hi  G",
		"Telenor  :[Sonofon  ]",
		"TDC Mobil",
		"Tele  ",
		"Telia   :[Orange  ]",
		"Lycamobile Denmark",
	],
	Djibouti: ["Evatis"],
	"East Timor": ["Timor Telecom", "Telkomsel Timor Leste"],
	Ecuador: ["CNT Mobile", "Movistar   :[Otecel  ]", "Porta   :[Conecel  ]"],
	Egypt: ["mobinil", "Vodafone", "Etisalat", "Telecom Egypt"],
	"El Salvador": [
		"*",
		"Telfonica",
		"CTE Telecom/Claro",
		"DIGICEL",
		"Telemovil  :[Tigo  ]",
	],
	"Equatorial Guinea": ["GETESA", "HiTs GESA"],
	Eritrea: ["Eritel"],
	Estonia: ["EMT", "Radiolinja Eesti", "Tele    Eesti"],
	Ethiopia: ["EthioMobile", "Safaricom"],
	"Faroe Islands": ["Faroese Telecom GSM", "Kall GSM  :[Vodafone  ]"],
	Micronesia: ["FSM Telecommunication Corporation"],
	Fiji: ["Vodafone", "Digicel Fiji Ltd", "Inkk Mobile  :[MVNO  ]"],
	Finland: [
		"Telia Finland",
		"Alands Telekommunikation",
		"Elisa Oyj",
		"DNA Verkot Oy",
		"Tismi BV   :[Finland  ]",
	],
	France: [
		"Orange France",
		"Bouygues T",
		"Soci   :[SFR  ]",
		"*",
		"Transatel",
		"Lycamobile",
		"Free Moblie",
		"Truphone France",
	],
	"French Guiana": ["Digicel Antilles Francaises Guyane"],
	"French Polynesia": ["VINI"],
	Gabon: [
		"Celtel   :[Airtel  ]",
		"Libertis",
		"TELECEL-moov",
		"Azur   :[USAN  ]",
	],
	Gambia: ["Comium", "Gamcel", "Qcell", "Africell"],
	Georgia: ["GeoCell", "Magti GSM   :[MagtiCom  ]", "QCell   :[Beeline  ]"],
	Germany: [
		"O  ",
		"*",
		"E-Plus",
		"MobilCom  :[Freenet  ]",
		"T-Mobile D",
		"vistream GmbH",
		"Vodafone D  ",
		"LycaMobile",
	],
	Ghana: [
		"Kasapa Telecom Ltd   :[CDMA  ]",
		"Mobitel   :[tiGO  ]",
		"Ghana Tel  :[Vodafone  ]",
		"Scancom Ltd   :[MTN  ]",
		"Zain   :[Airtel  ]",
		"Glo Mobile",
	],
	Gibraltar: ["Gibraltar", "Gibtelecom"],
	Greece: ["cosmote", "vodafone", "WIND  :[TIM  ]"],
	Greenland: ["Tele Greenland A/S"],
	Guadeloupe: [
		"Bouygues  :[Digicel  ]",
		"Saint Martin Et Saint Barthelemy Tel Cell SARL",
		"Dauphin Telecom",
	],
	Guatemala: ["Tigo", "Claro"],
	Guinea: ["Orange Guin", "Areeba-Guin", "Cellcom Guin", "Intercel"],
	"Guinea-Bissau": ["Orange Bissau", "Areeba  :[SpaceTel  ]"],
	Guyana: ["Digicel Guyana", "Guyana Telephone & Telegraph"],
	Haiti: [
		"Voila  :[ComCEL  ]",
		"Netcom  :[Rectel  ]",
		"Unigestion Holding S.A   :[Digicel  ]",
	],
	Honduras: [
		"Celtel   :[Tigo  ]",
		"Sercom   :[Claro  ]",
		"Digicel Hondura",
		"Empresa Hondurena",
	],
	"Hong Kong": [
		"Hong Kong Telecommunications   :[HKT  ] Limited",
		"China Motion Telecom   :[HK  ] Ltd",
		"China Mobile Hong Kong Company Limited",
		"SmarTone Mobile Communications Ltd",
		"China Unicom International Ltd",
		"CITIC Telecom         ",
		"Hong Kong CSL Ltd",
		"Hutchison - CDMA",
		"Hutchison  G   :[Hutchison Telecommunications Hong Kong Holdings Limited  ]",
		"Mandarin  :[PCCW- HKT  ]",
		"PCCW - HKT Telephone Ltd",
	],
	Hungary: ["Telenor   :[PANNON  ]", "vodafone", "T-Mobile", "DIGI Telecom"],
	Iceland: [
		"IceCell",
		"IMC Islande ehf   :[Viking  ]",
		"Nova ehf.",
		"Og fjarskipti hf.   :[Vodafone  ]",
		"Landss Siminn hf",
		"Tal",
	],
	Indonesia: [
		"Excelcomindo GSM",
		"Indosat  :[DCS  ]",
		"TelkomSel",
		"Hutchison",
		"*",
		"Axis",
		"Smart",
		"Telkom Flexi",
	],
	Iran: [
		"Irancell",
		"Mobile Communications Company of Iran   :[TCI  ]",
		"Talya",
		"Telecommunication Kish Co.   :[Kifzo  ]",
		"Rightel",
		"",
	],
	Iraq: [
		"ZAIN   :[formerly Atheer  ]",
		"ZAIN   :[formerly IRAQNA",
		"Korektel",
		"Asia Cell",
		"Itisaluna",
		"Iraqtel",
		"Mobitel",
	],
	Ireland: [
		"Vodafone Ireland plc",
		"Meteor",
		"Hutchison   G Ireland",
		"Clever Communication",
		"LIffey Telecom",
		"Lycamobile",
	],
	Israel: [
		"orange",
		"Cellcom",
		"Palestine   :[Jawaal  ]",
		"mirs",
		"Pelephone Communicat",
		"Wataniya Palestine",
		"Golan Telecom Ltd",
		"Telzar",
	],
	Italy: [
		"H  G S.p.A.   :[UMTS  ]",
		"RFI-Rete Ferroviaria Italiana S.p.A",
		"TIM Italia S.p.A",
		"Vodafone S.p.A.",
		"Wind Telecomunicazioni S.p.A",
		"*",
		"LycaMobile",
		"ILIAD Italy",
	],
	Japan: [
		"*",
		"Okinawa cellular",
		"Rakuten Mobile",
		"NTT Docomo Inc",
		"KDDI Corporation",
		"SoftBank Mobile",
	],
	Jordan: ["Fastlink  :[Zain  ]", "Orange  :[Mobilcom  ]", "UMNIAH"],
	Kenya: [
		"Airtel   :[celtel  ]",
		"Safaricom",
		"yu   :[Econet Wireless  ]",
		"Orange  :[Telkom Kenya  ]",
	],
	Kuwait: [
		"Zain  Mobile Telecommunication Company   :[MTC  ]",
		"wataniya telecom",
		"viva",
		"Virgin Mobile",
	],
	Kyrgyzstan: [
		"Beeline   :[Sky  ]",
		"BiMoCom   :[Megacom  ]",
		"O!   :[Nur Telecom  ]",
	],
	Laos: [
		"ETL",
		"Tango-Millicom-Tigo",
		"Unitel  :[Start  ]",
		"Lao Telecom   :[ETC  ]",
	],
	Lebanon: ["MTC Touch   :[MIC-    ]", "Alfa   :[MIC-    ]", "Liban Telecom"],
	Lesotho: ["Econet Ezi-Cel", "Vodacom"],
	Liberia: [
		"MTN  :[Lonestar  ]",
		"comium liberia",
		"Libercell",
		"Celcom Telecommunication Inc",
	],
	Libya: ["Al-Madar   :[Orbit  ]", "Libyana"],
	Liechtenstein: [
		"Mobilkom",
		"Telcom FL   :[Swisscom  ]",
		"Alpmobil   :[Tele    ]",
		"Viag   :[Orange  ]",
	],
	Lithuania: ["Bite GSM UAB", "Omnitel", "Tele   UAB"],
	Luxembourg: ["LuxGSM S.A", "Tango", "VOXmobile", "MTX", "JOIN"],
	Macau: [
		"Companhia de Telecomunica",
		"Hutchison Telephone",
		"SmarTone Mobile",
	],
	Macedonia: ["T-Mobile", "ONE   :[Cosmofon  ]", "VIP Operator"],
	Madagascar: ["Bharti Airtel", "Telma", "Orange"],
	Malawi: ["Bharti Airtel", "TNM", "Access Communication"],
	Malaysia: [
		"Celcom",
		"U Mobile",
		"maxis",
		"Digi",
		"Yes Mobile",
		"webe digital sdn bhd",
	],
	Maldives: ["Dhiraagu", "Wmobile   :[Wataniya Telecom  ]"],
	Mali: ["Malitel", "Orange Mali   :[Ikatel  ]", "ATEL-SA"],
	Malta: ["Go  :[Mobisle Commu  ]", "Vodafone Malta", "Melita Mobile"],
	"Marshall Islands": [
		"Islands National Telecommunications Authority   :[MINTA  ]",
	],
	Martinique: ["DIGICEL   :[Bouygues  ]"],
	Mauritania: ["Mauritel Mobiles"],
	Mauritius: ["Orange  :[Cell Plus  ]", "Emtel", "MTML"],
	Mexico: [
		"*",
		"Iusacell Pcs/Unefon",
		"Pegaso Com  :[Movistar  ]",
		"Telcel   :[Radiomovil  ]",
		"Nextel Mexico",
	],
	Moldova: ["Moldcell", "Voxtel  :[orange  ]", "Eventis Mobile", "Unit"],
	Monaco: ["Monaco Telecom"],
	Mongolia: [
		"MobiCom Co. Ltd",
		"Skytel",
		"Unitel Co. Ltd",
		"GMobile",
		"LIME",
		"ONDO Mobile",
	],
	Morocco: ["Itissalat   :[IAM  ]", "Medi Telecom", "INWI   :[Wana  ]"],
	Mozambique: ["Mcel", "Vodacom", "MOVITEL"],
	Myanmar: [
		"Myanmar Posts and Telecommunications   :[MPT  ]",
		"OOREDOO",
		"Telenor",
		"MYTEL",
	],
	Namibia: ["MTC Namibia   :[MTC  ]", "Leo   :[Orascom  ]"],
	Nauru: ["Digicel"],
	Nepal: [
		"Namaste  :[NTC Mobile  ]",
		"Ncell   :[Spice Nepal  ]",
		"Smart Telecom",
	],
	Netherlands: [
		"Barablu Mobile Benelux Ltd",
		"Blyk N.V   :[Elephan Ta",
		"KPN B.V",
		"Tele   Nederland B.V",
		"T-Mobile Netherlands B.V",
		"Vodafone Libertel B.V",
		"Lycamobile",
	],
	"Netherlands Antilles": [
		"Telcell",
		"Digicel   :[former Cura",
		"East Caribbean Cellular   :[CDMA  ]",
		"Radcomm",
		"UTS Wireless Cura",
	],
	"New Caledonia": ["Mobilis"],
	"New Zealand": [
		"vodaphone",
		"Telecom New Zealand   :[CDMA  ]",
		"   Degrees Mobile",
		"TelstraClear",
	],
	Nicaragua: ["SERCOM S.A.  :[Claro  ]", "Movistar NI"],
	Niger: ["Celtel-Niger", "orange", "Telecel-Niger"],
	Nigeria: [
		"Celtel   :[Airtel  ]",
		"globacom",
		"MTN",
		"  mobile",
		"Visafone Comm",
		"M-Tel",
	],
	Norway: [
		"TeliaSonera  :[Netcom  ]",
		"Network  :[MobileNorway",
		"Tele    :[Mobile Norway  ]",
		"Telenor Mobil",
		"Lycamobile",
		"Ventelo",
		"*",
	],
	Oman: ["Nawras   :[Qatari Tele  ]", "OmanMobile", "Vodafone"],
	Pakistan: [
		"Mobilink GSM",
		"ZONG   :[CMPak  ]",
		"Ufone   :[Pakistan Telecommunication Mobile Limited  ]",
		"Telenor Pakistan",
		"Warid Telecomminication",
		"SCO GSM",
	],
	Palau: [
		"Palau National Communications Corporation   :[PNCC  ]",
		"Palau Telecoms",
	],
	Panama: ["Claro", "Cable & Wireless Panam", "Telefonica Moviles", "Digicel"],
	"Papua New Guinea": ["Digicel   :[PNG  ] Ltd", "B-Mobile   :[PMC  ]"],
	Paraguay: ["Hola Paragu  :[VOXTEL  ]", "Claro", "Personal", "Telecel / Tigo"],
	Peru: [
		"*",
		"Nextel  :[Entel  ]",
		"Telefonica  :[Movistar  ]",
		"America Movil  :[Claro  ]",
	],
	Philippines: ["Globetelecom", "Smart", "Extelcom CDMA", "DITO"],
	Poland: [
		"orange",
		"Polska Telefonia Cyfrowa Era",
		"Polkomtel Plus",
		"P   Sp zoo",
		"E-Telko Sp. z o.o.",
		"Tele   Polska  :[Netia  ]",
		"Telekomunikacja Kole",
		"*",
		"Mobyland Sp. z o.o.",
		"CenterNet S.A.",
		"Cyfrowy POLSAT  :[MVNO  ]",
	],
	Portugal: ["vodafone", "optimus", "TMN", "Portugal LycaMobile"],
	Qatar: ["Q-Tel", "vodaphone"],
	"South Korea": ["KT Freetel", "LG Telecom", "SK Telecom"],
	Reunion: ["Outremer T", "Orange R", "Soci  :[SRR  ]"],
	Romania: [
		"orange",
		"Romania Data Systems   :[DIGI.mobil  ]",
		"Cosmote Rom",
		"Vodafone Rom",
		"Telemobil-Zapp  :[CDMA  ]",
	],
	Rwanda: [
		"RWANDATEL S.A.",
		"TIGO RWANDA S.A",
		"MTN Rwandacell SARL",
		"Rwanda Airtel",
	],
	Samoa: ["Digicel"],
	"Sao Tome and Principe": ["CSTmovel"],
	"Saudi Arabia": [
		"Saudi Telecom Company   :[STC  ]",
		"Etihad Etisalat Company   :[Mobily  ]",
		"zain",
		"Virgin Mobile",
		"Lebara Mobile",
	],
	Senegal: [
		"Expresso   :[Sudatel  ]",
		"Sonatel   :[Alize  ]",
		"Tigo   :[Sentel GSM  ]",
	],
	Seychelles: [
		"Cable and Wireless   :[Seychelles  ] Ltd",
		"MediaTech",
		"Telecom   :[Seychelles  ] Ltd",
	],
	"Sierra Leone": [
		"Comium Sierra leone INC",
		"Africell   :[SL  ]Ltd PCS",
		"Celtel   :[SL  ] Ltd",
		"Datatel   :[SL  ] Ltd GSM",
		"Millicom   :[SL  ] Ltd",
		"QCELL  :[SL  ] LIMITED",
	],
	Singapore: [
		"StarHub",
		"m  ",
		"*",
		"Singapore Telecom",
		"ST Sunpage",
		"TPG Telecom",
	],
	Slovakia: [
		"T-Mobile UMTS",
		"Orange  :[globatel  ]",
		"Telefonica O  ",
		"  Ka",
	],
	Slovenia: [
		"Si.Mobil-Vodafone",
		"T-   d.o.o.",
		"Western Wireless  :[Tusmobil d.o.o.  ]",
		"Mobitel",
	],
	"Solomon Islands": [
		"Solomon Telekom Company Ltd   :[BREEZE  ]",
		"BMobile Limited",
	],
	Somalia: [
		"NationLink Telecom",
		"Telesom",
		"Bosaso Golis",
		"Hargeysa Telesom",
		"Somafone",
		"HORMUUD",
		"MOGADISHU",
		"AMTEL LTD",
	],
	"South Africa": [
		"vodacom",
		"mtn",
		"cell c",
		"USAL licence holders",
		"*",
		"Telkom Mobile   :[  TA  ]",
	],
	Spain: [
		"Vodafone",
		"Xfera M  :[Yoigo  ]",
		"*",
		"Bt Espa",
		"Cableuropa S a u",
		"E-plus M  :[Simyo  ]",
		"Euskaltel S a",
		"FranceTelecom  :[Orange",
		"Jazz Telecom S a u",
		"R Cable Y Telecomunicaciones Galicia",
		"Telecable De Asturias",
		"Telefonica  :[Movistar  ]",
		"Lycamobile Spain",
		"Lleida Networks",
		"Fonyou",
		"Llamaya",
	],
	"Sri Lanka": [
		"Bharti Airtel Lanka   :[Pvt  ]",
		"Etisalat",
		"Hutchison",
		"Mobitel",
		"MTN Dialog  :[Axiata  ]",
	],
	Sudan: ["Mobitel  :[Zain  ]", "Areeba Sudan  :[MTN  ]", "Sudani One"],
	Suriname: ["Digicel Suriname N.V.", "  :[Uniqa  ] Intelsur", "Telesur"],
	Sweden: [
		"Comviq   :[Tele    ]",
		"TeliaSonera",
		"Hi  G",
		"Telenor   :[Vodafone Europolitan  ]",
		"Lycamobile Sweden",
		"Tigo Ltd",
		"Wireless Maingate",
		"Mundio Mobile",
		"TDC Mobil",
		"     Telecom",
		"Beepsend",
		"INFOBIP LIMITED",
		"*",
	],
	Switzerland: [
		"orange",
		"sunrise",
		"Bebbicell AG",
		"Comfone AG",
		"In&Phone SA",
		"Swisscom Mobile AG",
		"Tele   Telecommunication Services AG",
		"LycaMobile",
	],
	Syria: ["syriatel", "MTN Syria"],
	Taiwan: [
		"Chunghwa Telecom LDM",
		"MobiTai",
		"Far EasTone",
		"KG Telecom",
		"Taiwan Mobile",
		"TransAsia",
		"T-Star  :[VIBO  ] Telecom",
		"Asia Pacific Telecom   :[APT  ]",
	],
	Tajikistan: [
		"Tcell   :[INDIGO  ]",
		"Tcell   :[Somoncom  ]",
		"Babilon Mobile",
		"TAKOM   :[Beeline  ]",
		"MLT   :[TT-Mobile  ] Megafone",
	],
	Tanzania: [
		"Bharti Airtel",
		"Vodacom",
		"MIC   :[Tigo  ] Ltd.",
		"Tanzania Telecom-munications Company Ltd.",
		"Vodacom   :[T  ] Ltd.",
		"Zantel   :[Zanzibar  ]",
		"Smart",
		"SMILE",
		"Halotel  :[Viettel  ]",
	],
	Thailand: [
		"*",
		"Advanced Info Service PLC   :[AIS GSM  ]",
		"CAT",
		"CAT CDMA",
		"Digital Phone Co Ltd  :[GSM           ]",
		"HUTCH CDMA",
		"NMT CDMA",
		"TOT   G   :[Thai Mobile  ]",
		"Total Access Communications Co  :[DTAC  ]",
		"True Move Company Ltd  :[True Move  ]",
	],
	Togo: ["Telecel", "Togocel"],
	Tonga: ["Shoreline   :[Tonfon  ]", "U-Call", "Digicel Tonga"],
	Tunisia: ["Tunisiana  :[Orascom  ]", "TunisieTelcom  :[TUNTEL", "Orange"],
	Turkey: [
		"turkcell",
		"Telsim   :[Vodafone  ]",
		"AVEA  :[Aria  ]",
		"Northern Cyprus-TRNC",
	],
	Turkmenistan: ["BCTI", "TM-Cell"],
	Uganda: [
		"Airtel Uganda",
		"MTN   :[Uganda  ] Ltd",
		"Uganda Telecom Ltd",
		"Orange  :[Africell  ]",
		"Suretelecom",
		"Tangerine",
	],
	Ukraine: [
		"life  :[Astelit  ]",
		"Kyivstar",
		"MTS Ukraine   :[UMC  ]",
		"Golden Telecom",
		"Telesystems   :[CDMA  ]",
		"Ukrtelecom",
	],
	"United Arab Emirates": ["etisalat", "du"],
	"United Kingdom": [
		"UK O   LTD",
		"UK Hutchison   G Ltd",
		"UK Orange",
		"T-Mobile   :[UK  ] Ltd",
		"Cable & Wireless Guernsey Ltd",
		"*",
		"UK BT",
		"UK OnePhone LTD",
		"UK Routo Telecommunications LTD",
		"Truphon SoftCellular",
		"UK Teleware plc",
		"UK Vodafone LTD",
		"UK Wave Telecom LTD",
		"Guernsey C & W  Limited",
		"Guernsey Airtel Limited",
		"Isle of Man Manx Telecom",
		"Jersey Airtel Limited",
		"Jersey Telecom",
		"Cloud  ",
		"Lycamobile UK Limted",
		"Everything Everywher",
		"all operator",
		"Sky UK Limited",
		"Telet Research   :[N.I.  ] Limited",
		"TANGO NETWORKS UK LTD",
		"Tismi BV   :[UK  ]",
		"Stour Marine Limited",
	],
	Uruguay: [
		"Antel   :[Compania  ]",
		"Telef  :[Movistar  ]",
		"Claro  :[AM Wireless  ]",
	],
	Uzbekistan: [
		"Buztel",
		"Coscom  :[UCell  ]",
		"Uzdunrobita",
		"Uzmacom",
		"Unitel  :[Beeline  ]",
		"Uzbektelecom Joint-Stock Company",
	],
	Vanuatu: ["Digicel   :[Vanuatu  ] Ltd", "Telecom Vanuatu Ltd"],
	Venezuela: ["Digitel", "Movilnet", "Movistar"],
	Vietnam: [
		"MobiFon",
		"S-Fone   :[CDMA  ]",
		"Viettel Mobile",
		"VinaPhone  :[VNPT  ]",
		"HT Mobile   :[Vietnamo  ]",
		"BEELINE   :[GTEL  ]",
		"Reddi",
	],
	Yemen: ["Sabafon", "MTN", "Yemen Mobile  :[CDMA  ]", "Y   :[HiTS-Unitel  ]"],
	Serbia: ["Telekom Srbija a.d.", "Telenor d.o.o.", "Vip mobile d.o.o."],
	Zambia: ["CelTel", "MTN  :[Telecel  ]", "Zamtel MTS"],
	Zimbabwe: ["Econet", "NetOne", "Telecel"],
	Palestine: ["jawwal", "Wataniya Palestine"],
	"Ivory Coast": [
		"*",
		"Atlantique Cellulaire   :[MOOV  ]",
		"Comium Ivory Coast Inc   :[KoZ  ]",
		"MTN C",
		"Orange C",
		"Oricel C",
	],
	BARBADOS: [
		"Cable&Wireless",
		"Digicel Barbados Ltd.",
		"Sunbeach Communications",
	],
	Jamaica: ["*", "Digicel Jamaica", "Cable&Wireless  :[LIME  ]"],
	Latvia: [
		"Bite Latvija",
		"IZZI",
		"Latvijas Mobilais Telefons   :[LMT  ]",
		"MTS GSM",
		"Tele  ",
		"Triatel",
	],
	"American Samoa": ["Blue Sky Comm"],
	Anguilla: ["Cable & Wireless   :[GSM  ]", "Weblinks", "Wireless Ventu Digi"],
	"Antigua and Barbuda": [
		"APUA PCS",
		"Digicel Antigua",
		"Cable & Wireless   :[An",
	],
	Bahamas: ["BaTelCel"],
	Bermuda: ["Digicel", ""],
	Grenada: ["Cable and Wireless", "Digicel"],
	"Saint Kitts and Nevis": ["Cable & Wireless", "Digicel"],
	"Saint Lucia": ["Cable & Wireless St. Lucia", "Digicel St. Lucia"],
	"Trinidad and Tobago": [
		"Digicel Trinidad and Tobago Ltd",
		"Telecom of Trinidad and Tobago",
	],
	"Turks and Caicos Islands": [
		"Cable and Wireless   :[GSM  ]",
		"Digicel   :[TCI  ] Ltd",
		"IslandCom Communication Ltd",
	],
	"British Virgin Islan": [
		"Cable & Wireless   :[West Indies  ]",
		"Digicel   :[BVI  ] Ltd",
	],
	"Dominican Repblic": [
		"Trilogy_Domini  :[Viva  ]",
		"Compania  :[Claro  ]",
		"Orange Dominicana",
		"Tricom",
	],
	"Dominica Commnwealth": ["Digicel Dominica", "Cable & Wireless Dom"],
	"Puerto Rico": ["AT&T  :[New Cingular  ]", "PRTC  :[Claro  ]"],
	"Russian Federation": [
		"Extel  :[Bee Line  ]",
		"Mobile TeleSystems",
		"MegaFon",
		"MOTIV  :[Ekaterinburg          GSM  ]",
		"TELE   Teleset",
		"Nizhny Novgorod Cellular Communications",
		"AKOS",
		"Eniseytelekom  :[ETK  ]",
		"Rostelecom",
		"Baykalvestkom",
		"New Telephone Company",
		"SMARTS",
		"Altaysvyaz",
		"Don Telecom",
		"VTC-MOBILE",
		"SPRINT",
	],
	Montenegro: ["Telenor  :[ProMonte  ]", "T-Mobile", "m:tel CG"],
	Swaziland: ["Swazi MTN Limited"],
	"St. Vincent & Grenad": [
		"C & W   :[Cable and Wireless  ]",
		"Digicel St Vincent & Gren.",
	],
	"USA-Canada": [
		"Aliant Telecom   :[Mobility  ]",
		"Bell Mobility",
		"Cable & Wireless",
		"Digicel",
		"Fido Solutions Inc",
		"Globalive Wireless Mngmt",
		"New Cingular Wireless Pcs",
		"NorthernTel Limited Partnership",
		"Northwestel Mobility Inc",
		"Omnipoint Communications",
		"Rogers",
		"SaskTel Mobility",
		"Sprint Spectrum L.p",
		"Telebec Limited Partnership",
		"TELUS Mobility",
		"TELUS Quebec",
		"Thunder Bay Mobility",
		"T-mobile Usa",
		"Powertel",
		"Level    Communicatio",
		"Verizon Wireless",
		"Cellco Partnership D",
		"Landline",
		"MetroPCS",
		"Cricket Communicatio",
		"Nextel Communication",
		"All CDMA Networks",
		"*",
		"block",
		"Dave Wireless",
	],
	Montserrat: ["Cable & Wireless", "Digicel"],
	"Dominican Repblic": [
		"Orange Dominicana",
		"Compania  :[Claro  ]",
		"Trilogy_Domini  :[Viva  ]",
		"Tricom",
	],
	"Dominican Repblic": [
		"Orange Dominicana",
		"Compania  :[Claro  ]",
		"Trilogy_Domini  :[Viva  ]",
	],
	"South Sudan": [
		"Gemtel Mobile",
		"Mtn Mobile",
		"Southtel Mobile",
		"Vivacell Mobile",
		"Zain Mobile",
		"Digitel Telecom",
	],
	India: [
		"IDEA_UP-West",
		"Reliance_Madhya Pradesh",
		"Reliance_Gujarat",
		"Reliance_Rajasthan",
		"Reliance_Maharashtra",
		"VODAFONE_Maharashtra",
		"VODAFONE_Gujarat",
		"VODAFONE_Orissa",
		"VODAFONE_West Bengal",
		"Unitech Wireless_Tamil Nadu",
		"Unitech Wireless_Bihar",
		"Unitech Wireless_Andhra Pradesh",
		"AIRTEL_Madhya Pradesh",
		"AIRTEL_UP-East",
		"AIRTEL_Assam",
		"AIRTEL_UP-West",
		"AIRTEL_Orissa",
		"AIRTEL_Andhra Pradesh",
		"Tata Teleservices_Tamil Nadu",
		"Tata Teleservices_Karnataka",
		"Tata Teleservices_Orissa",
		"Tata Teleservices_Haryana",
		"Tata Teleservices_Andhra Pradesh",
		"Tata Teleservices_Mumbai",
		"Tata Teleservices_Bihar",
		"AIRTEL_Bihar",
		"AIRTEL_Karnataka",
		"Tata Teleservices_UP-East",
		"Tata Teleservices_Maharashtra",
		"AIRCEL_Bihar",
		"AIRCEL_Kolkata",
		"AIRCEL_Kerala",
		"AIRCEL_Jammu & Kashmir",
		"AIRCEL_Chennai",
		"AIRCEL_Tamil Nadu",
		"BSNL_UP-East",
		"IDEA_Orissa",
		"Reliance_Andhra Pradesh",
		"VODAFONE_UP-East",
		"Unitech Wireless_UP-East",
		"AIRCEL_Assam",
		"Tata Teleservices_Madhya Pradesh",
		"Tata Teleservices_UP-WEST",
		"Reliance_Delhi",
		"Reliance_Kerala",
		"Reliance_Kolkata",
		"Reliance_Karnataka",
		"Reliance_Bihar",
		"Reliance_Mumbai",
		"Reliance_UP-East",
		"Tata Teleservices_West Bengal",
		"AIRCEL_Delhi",
		"AIRCEL_Orissa",
		"Reliance_UP-WEST",
		"VODAFONE_Bihar",
		"VODAFONE_Madhya Pradesh",
		"AIRTEL_Rajasthan",
		"BSNL_Tamil Nadu",
		"AIRTEL_Gujarat",
		"AIRTEL_West Bengal",
		"VODAFONE_Tamil Nadu",
		"IDEA_Bihar",
		"VODAFONE_Rajasthan",
		"Reliance_Tamil Nadu",
		"Reliance_West Bengal",
		"Tata Teleservices_Punjab",
		"IDEA_Madhya Pradesh",
		"IDEA_Gujarat",
		"IDEA_West Bengal",
		"AIRTEL_Tamil Nadu",
		"AIRTEL_Maharashtra",
		"Reliance_Orissa",
		"Tata Teleservices_Kerala",
		"Tata Teleservices_Rajasthan",
		"AIRTEL_Mumbai",
		"Tata Teleservices_Delhi",
		"VODAFONE_Andhra Pradesh",
		"Reliance_Punjab",
		"VODAFONE_Karnataka",
		"VODAFONE_UP-WEST",
		"VODAFONE_Punjab",
		"VODAFONE_Delhi",
		"IDEA_UP-East",
		"Reliance_Haryana",
		"IDEA_Kolkata",
		"IDEA_Rajasthan",
		"AIRCEL_North East",
		"VODAFONE_Kolkata",
		"VODAFONE_Haryana",
		"IDEA_Haryana",
		"LOOP Telecom_Mumbai",
		"VODAFONE_Kerala",
		"Tata Teleservices_Himachal Pradesh",
		"IDEA_Andhra Pradesh",
		"Shyam Telelink_Rajasthan",
		"IDEA_Mumbai",
		"IDEA_Tamil Nadu",
		"AIRTEL_Kerala",
		"AIRTEL_Punjab",
		"VODAFONE_North East",
		"AIRCEL_Maharashtra",
		"AIRTEL_Delhi",
		"AIRCEL_Andhra Pradesh",
		"IDEA_Maharashtra",
		"Reliance_Assam",
		"VIDEOCON_Mumbai",
		"Tata Teleservices_Gujarat",
		"IDEA_Punjab",
		"VODAFONE_Assam",
		"VODAFONE_Mumbai",
		"AIRCEL_Karnataka",
		"AIRTEL_Himachal Pradesh",
		"BSNL_Orissa",
		"AIRCEL_UP-East",
		"AIRCEL_Mumbai",
		"BSNL_West Bengal",
		"BSNL_Haryana",
		"BSNL_Kolkata",
		"AIRCEL_West Bengal",
		"AIRCEL_UP-WEST",
		"Unitech Wireless_UP-West",
		"Shyam Telelink_Tamil Nadu",
		"Shyam Telelink_West Bengal",
		"VODAFONE_Chennai",
		"Tata Teleservices_Kolkata",
		"IDEA_Karnataka",
		"AIRTEL_North East",
		"BSNL_Andhra Pradesh",
		"BSNL_Bihar",
		"BSNL_Himachal Pradesh",
		"BSNL_Madhya Pradesh",
		"AIRTEL_Kolkata",
		"MTNL_Delhi",
		"Reliance_Jammu & Kashmir",
		"VIDEOCON_Assam",
		"IDEA_Assam",
		"IDEA_Jammu & Kashmir",
		"IDEA_North East",
		"Shyam Telelink_Delhi",
		"Shyam Telelink_Gujarat",
		"Shyam Telelink_Karnataka",
		"Shyam Telelink_Kerala",
		"Shyam Telelink_Kolkata",
		"Shyam Telelink_UP-WEST",
		"Unitech Wireless_Mumbai",
		"Unitech Wireless_Gujarat",
		"Unitech Wireless_Maharashtra",
		"BSNL_Assam",
		"BSNL_Chennai",
		"BSNL_Gujarat",
		"BSNL_Jammu & Kashmir",
		"BSNL_Karnataka",
		"BSNL_Kerala",
		"BSNL_North East",
		"BSNL_Punjab",
		"BSNL_Rajasthan",
		"Tata Teleservices_Jammu & Kashmir",
		"Tata Teleservices_North East",
		"Tata Teleservices_Assam",
		"Reliance_Himachal Pradesh",
		"Reliance_Chennai",
		"BSNL_Maharashtra",
		"BSNL_UP-WEST",
		"Etisalat_Maharashtra",
		"Etisalat_Gujarat",
		"Etisalat_Karnataka",
		"Etisalat_Tamil Nadu",
		"Etisalat_Andhra Pradesh",
		"Etisalat_Kerala",
		"Etisalat_Punjab",
		"Etisalat_Haryana",
		"Etisalat_UP-East",
		"Etisalat_UP-WEST",
		"Etisalat_Rajasthan",
		"Etisalat_Madhya Pradesh",
		"Etisalat_Bihar",
		"IDEA_Kerala",
		"IDEA_Delhi",
		"AIRTEL_Chennai",
		"Etisalat_Mumbai",
		"AIRTEL_Jammu & Kashmir",
		"Etisalat_Delhi",
		"Reliance_North East",
		"VIDEOCON_Punjab",
		"AIRCEL_Gujarat",
		"AIRTEL_Haryana",
		"VODAFONE_Himachal Pradesh",
		"MTNL_Mumbai",
		"AIRCEL_Rajasthan",
		"VODAFONE_Jammu & Kashmir",
		"AIRCEL_Haryana",
		"AIRCEL_Punjab",
		"AIRCEL_Madhya Pradesh",
		"AIRCEL_Himachal Pradesh",
		"IDEA_Himachal Pradesh",
		"*",
		"Reliance JIO_Andhra Pradesh",
		"Reliance JIO_Assam",
		"Reliance JIO_Delhi",
		"Reliance JIO_Himachal Pradesh",
		"Reliance JIO_Jammu & Kashmir",
		"Reliance JIO_Karnataka",
		"Reliance JIO_Kerala",
		"Reliance JIO_Kolkata",
		"Reliance JIO_Orissa",
		"Reliance JIO_Rajasthan",
		"Reliance JIO_Tamil Nadu",
		"Reliance JIO_UP-East",
		"Reliance JIO_UP-West",
		"Reliance JIO_West Bengal",
		"Reliance JIO_Maharashtra",
		"Reliance JIO_Mumbai",
		"Reliance JIO_Bihar",
		"Reliance JIO_Gujarat",
		"Reliance JIO_Haryana",
		"Reliance JIO_Madhya Pradesh",
		"Reliance JIO_Punjab",
		"Reliance JIO_North East",
		"HFCL_Punjab",
	],
	"Cayman Islands": ["Cable & Wireless", "Digicel Cayman Ltd"],
	Kazakhstan: ["Beeline", "K-Cell", "Kazakhtelekom", "Tele  -MTS"],
	Kosovo: ["Ipkonet"],
	Abkhazia: ["JV   :[A-Mobile  ]", "Aquafon"],
};

const operatorCache = {};

export function getOperator(phoneNumber) {
	// Check cache first
	if (operatorCache[phoneNumber]) {
		return operatorCache[phoneNumber];
	}

	const countries = findCountryByPhoneNumber(phoneNumber);
	let data;
	if (countries === "Canada" || countries === "United States") {
		data = countryAndOperators["USA-Canada"];
	} else if (countries === "Russia") {
		data = countryAndOperators["Russian Federation"];
	} else if (countries.includes("Republic of the Congo")) {
		data = countryAndOperators["Congo"];
	} else {
		data = countryAndOperators[countries];
	}

	const random = data ? data[Math.floor(Math.random() * data.length)] : "N/A";

	// Store the result in the cache
	operatorCache[phoneNumber] = random;

	return random;
}
